import publicService from './api/public'
import backofficeService from './api/backoffice'
import organizationSerivce from './modules/Organization/service'

export default {
  namespaced: true,
  state: {
    currentUser: {},
    globalStatus: true,
    loginDialog: false,
    loadingStatus: {
      status: false,
      title: 'Please Wait',
    },
    States: [],
    search: null,
    ComboBox: [],
    Modules: [],
    Countries: [],
    defaultCountryCode: 840,
    currentOrganization: {},
  },
  getters: {
    search(state) {
      return state.search
    },
    loginDialog(state) {
      return state.loginDialog
    },
    globalStatus(state) {
      return state.globalStatus
    },
    loadingStatus(state) {
      return state.loadingStatus
    },
    comboBoxByID: (state) => (id) => {
      return state.ComboBox.find(row => row.comboBoxTypeId === id)
    },
    checkRightStatus: (state) => (id) => {
      let userRight = state.currentUser.userRights.split(",")
      let returnValue = false
      userRight.map(row => {
        if (Number(row) === id) {
          returnValue = true
        }
      })
      return returnValue
    },
    ComboBox(state) {
      return state.ComboBox
    },
    currentUser(state) {
      return state.currentUser
    },
    currentOrganization(state) {
      return state.currentOrganization
    },
    states(state) {
      return state.States
    },
    comboBox(state) {
      return state.ComboBox
    },
    modules(state) {
      return state.Modules
    },
    countries(state) {
      return state.Countries
    },
    defaultCountryCode(state) {
      return state.defaultCountryCode
    },
  },
  actions: {
    setSearch({
      commit
    }, payload) {
      commit('setSearch', payload)
    },
    checkRightStatus({
      commit
    }, id) {
      document.title = title
    },
    setPageTitle({
      commit
    }, title) {
      document.title = title
    },
    setLoginDialog({
      commit
    }, payload) {
      commit('setLoginDialog', payload)
    },
    setGlobalStatus({
      commit
    }, payload) {
      commit('setGlobalStatus', payload)
    },
    setLoadingStatus({
      commit
    }, payload) {
      commit('setLoadingStatus', payload)
    },
    sendEmail({
      commit
    }, address) {
      let routeData = "https://mail.google.com/mail/?view=cm&fs=1&to=" + address
      window.open(routeData, 'newwindow', 'width=800, height=950');
    },
    initComboBox({
      commit
    }) {
      return publicService.ComboBox()
        .then((response) => {
          commit('initComboBox', response.data)
        })
    },
    initState({
      commit
    }) {
      return publicService.States()
        .then((response) => {
          commit('initState', response.data)
        })
    },
    initModules({
      commit
    }) {
      return publicService.Modules()
        .then((response) => {
          console.log('state', response)
          commit('initModules', response.data)
        })
    },
    initCountries({
      commit
    }) {
      return publicService.Country()
        .then((response) => {
          commit('initCountries', response.data)
        })
    },
    initUser({
      commit
    }) {
      return backofficeService.Api().get('api/user/current')
        .then((response) => {
          commit('initUser', response.data.data)
        })
    },
    initOrganization({
      commit,
      dispatch
    }, payload) {
      console.log('test org running')
      if (!payload) {
        const id = localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}organizationId`)
        if (id) {
          return organizationSerivce.getById(id)
            .then((response) => {
              if (!response.data) {
                throw new Error('No organization found.')
              }
              commit('initOrganization', response.data)
            })
            .catch((error) => {
              console.log('in here error', error)
              throw error
            })
        }
        // throw new Error('No organization found.')
      } else {
        commit('initOrganization', payload)
        return dispatch('initOrganizationId', payload.id)
      }
    },
    initOrganizationId({
      commit
    }, payload) {
      return new Promise((resolve, reject) => {
        if (payload) {
          localStorage.setItem(`${process.env.VUE_APP_STORAGE_PREFIX}organizationId`, payload)
        } else {
          payload = localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}organizationId`)
        }
        if (!payload) {
          return reject()
        }
        return resolve()
      })
    },
  },
  mutations: {
    setSearch(state, payload) {
      state.search = payload
    },
    initComboBox(state, payload) {
      state.ComboBox = payload
    },
    initState(state, payload) {
      state.States = payload
    },
    initModules(state, payload) {
      state.Modules = payload
    },
    initCountries(state, payload) {
      state.Countries = payload
    },
    initUser(state, payload) {
      state.currentUser = payload
    },
    setGlobalStatus(state, payload) {
      state.globalStatus = payload
    },
    setLoginDialog(state, payload) {
      state.loginDialog = payload
    },
    setLoadingStatus(state, payload) {
      state.loadingStatus = payload
    },
    initOrganization(state, payload) {
      state.currentOrganization = payload
    },
  },
}
